import guest from "@/core/middlewares/guest";

let login = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/Login');

export default [
    {
        path: "/accounts",
        redirect: "/accounts/login",
        component: () => import("@/views/authentication/Layout"),
        children: [
            {
                path: "login",
                name: "login",
                component: login,
                meta: {
                    middleware: guest,
                    title: "ورود "
                }
            }
        ]
    }
]